import React from 'react';

import {
  Button,
  Heading,
  Icon,
  IconButton,
  SegmentedControl,
  Skeleton,
  Text
} from '@albert-io/atomic';

import {SkeletonRow} from 'client/TeacherDashboard/components/ListRowsSkeleton';

import {STATUS_SEGMENTS} from './constants';

// The list reveals only once counts have loaded, so the real segments always carry a total. The
// placeholder digits keep the masked control the same width as the one that replaces it.
const SEGMENTS_WITH_COUNTS = STATUS_SEGMENTS.map((s) => ({
  ...s,
  label: (
    <>
      {s.label} <span className='ml-x0-half content-tertiary'>(00)</span>
    </>
  )
}));

export const SkillPathsViewSkeleton = () => (
  <div aria-busy='true' className='gap-x4 pt-x4 flex flex-col'>
    <span className='sr-only' role='status'>
      Loading diagnostics and skill paths…
    </span>
    <Heading as='h2' className='m-x0' size='s'>
      Skill Paths
    </Heading>
    <div aria-hidden='true' className='gap-x2 flex flex-wrap items-center justify-between'>
      <Skeleton>
        <SegmentedControl
          buttonClassName='font-normal'
          options={SEGMENTS_WITH_COUNTS}
          selectedIdx={0}
        />
      </Skeleton>
      <div className='gap-x1 flex items-center'>
        <Skeleton>
          <Button color='secondary' variant='outlined'>
            <Icon className='mr-x1' icon='bars-filter' />
            <Text color='inherit'>Filters</Text>
          </Button>
        </Skeleton>
        <Skeleton>
          <Button color='secondary' variant='outlined'>
            <Icon className='mr-x1' icon={['far', 'arrow-down-short-wide']} />
            <Text color='inherit'>Sort</Text>
          </Button>
        </Skeleton>
        <Skeleton>
          <IconButton
            aria-hidden
            color='secondary'
            icon='magnifying-glass'
            roundness='square'
            variant='outlined'
          />
        </Skeleton>
      </div>
    </div>
    <div aria-hidden='true' className='flex flex-col'>
      {['r1', 'r2', 'r3', 'r4', 'r5', 'r6'].map((key) => (
        <SkeletonRow key={key} />
      ))}
    </div>
  </div>
);
